const FranchisesSearchType = (state = {}, action) => {
  switch (action.type) {
    case 'INITIAL_FRANCHISES_SEARCH_TYPES':
      return action.data
    default:
      return state;
  }
};

export default FranchisesSearchType;